
export function setRequesterId(state, data) {
    state.requester_id = data
}

export function setClientId(state, data) {
    state.client_id = data
}



